<template>
  <div class="detail-page">
    <van-nav-bar
      ref="nav"
      :border="false"
      @click-left="back"
      placeholder
      :fixed="true"
      :title="name || '课程详情'"
    >
      <template #left>
        <van-icon size="20px" name="arrow-left" color="#333" />
      </template>
    </van-nav-bar>
    <van-popup v-model="show" position="bottom">
      <div class="share-box">
        <div
          @click="
            show2 = true;
            show = false;
          "
        >
          <img
            src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share3.png"
            alt=""
          />
          微信
        </div>
        <div @click="copy">
          <img
            src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share2.png"
            alt=""
          />
          复制链接
        </div>
      </div>
    </van-popup>
    <div class="share-wrap" @click="show2 = false" v-show="show2">
      <img
        src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share1.png"
        alt=""
      />
      <img
        src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share4.png"
        alt=""
      />
    </div>
    <!-- <div class="video-wrap">
      <div class="share" @click="show = true">
        <img
          src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/share_icon.png"
        />
        分享
      </div>
    </div> -->
  
    <div
      class="tab-content"
      :style="{ paddingBottom:'200px'}"
    >
    
      
      <div class="lesson-title">{{ name }}</div>
      <div class="lesson-img html-view" v-html="content_img"></div>
    </div>
    
    <div class="footer" >
      <div class="lesson" v-if="!is_buy" @click="goOrderMake">会员购买 ¥{{ price }}</div>
    </div>
  </div>
</template>

<script>
import CertSave from '../CertSave.vue';
export default {
  components: {CertSave},
  computed: {
    partalName() {
      return this.$store.state.plat.name;
    },
     plat() {
      return this.$store.state.plat_id
    }
  },
  data() {
    return {
      show: false,
      show2: false,
      videoContext: "",
      active: -1,
      playId: 0,
      price: "",
      content_app: "",
      content_img: "",
      name: "",
      lessonList: [],
      is_buy: 0,
      is_vip: 0,
      player: "",
      goods_sku_id: "",
      scrollLeft: "",
      examinInfo:null,
      currentInfo:null,
      duration:0,
      currentTime:'',
      timeStart:0,
      color: ['#666', '#FF4D41', '#6DD400'],
    };
  },
  async mounted() {
    this.active = 1
    let res = await this.$api({
      // url: "/api/goods/parent/lesson",
      url:"/api/platform/goods/detail",
      data: {
        goods_id: this.$route.query.id,
      },
    });
    if (res.code == 0) {
      console.log(res.data);
      let { is_buy, is_vip, goods_arr, list, base } = res.data;
      this.is_buy = is_buy;
      this.is_vip = is_vip;
      this.lessonList = list;
      this.examinInfo = base
      this.price = goods_arr[0].price;
      this.content_img = goods_arr[0].content_app;
      this.name = goods_arr[0].name;
      this.goods_sku_id = goods_arr[0].goods_sku_id;
      let playList = list.filter((e) => {
        return e.is_show == 1;
      });
      // this.playVideo("", playList[0]);
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    
    goOrderMake() {
      if(!localStorage.getItem('userdata')){
        this.$toast("请登录后购买");
        return
      }
      if (this.goods_sku_id) {
        this.$router.push({
          path:'../order/make?goods_sku_id=' + this.goods_sku_id
        })
        // this.$store.dispatch("authJump", {
        //   path: "/pages/order/make",
        //   params: "goods_sku_id=" + this.goods_sku_id,
        // });
      }
    },
 
    
    async addHistory() {
      let data = this.currentInfo
      let res = await this.$api({
          method:'post',
          url:'/api/users/flat/record',
          data:{
          lesson_id: data.lesson_id,
          goods_course_id: data.goods_course_id,
          status: this.currentTime===data.resource[0].ali_duration ? 1 : 0,
          duration: this.duration,
          flat_id: this.plat,
          playmode_id: data.id
        }
      })
      if (res.code == 0) {
        console.log(res.data);
      }
      this.timeStart = 0
    },
  },
};
</script>

<style scoped>
.examin-content{
  display: flex;
  align-items: center;
  width: 9.2rem;
  background: #fff;
  border-radius: 0.16rem;
  overflow: hidden;
  margin-bottom: 0.26667rem;
  padding: 30px 20px;
  margin: 0.3rem auto;
}
.examin-content .examinBtn{
  text-align: center;
  padding: 10px 20px;
  background: rgb(164, 0, 1);
  color: #fff;
  border-radius: 5px;
}
.opacity{
  opacity: 0.5;
}
.examin-content .examinLeft{
  flex:1
}
.examin-content .examinLeft .examinTitle{
  color: #000;
  width: 100%;
  font-size: 34px;
  margin-bottom: 16px;
}
.examin-content .examinLeft .examinDesc{
  margin-bottom: 40px;
  font-size: 14px;
}
.examin-content .examinLeft .score{
  font-size: 14px;
}
.examin-content .examinLeft .score span{
   margin-right:50px
}
.detail-page {
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
}

.video-wrap {
  width: 750px;
  height: 400px;
  position: relative;
}

.detail-page .video {
  width: 100%;
  height: 100%;
  background: #000;
}

.detail-page .share {
  position: absolute;
  right: 0;
  top: 37px;
  width: 109px;
  height: 52px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 27px 0 0 27px;
  color: #ddd;
  font-size: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}

.detail-page .share img {
  width: 24px;
  margin-right: 4px;
}

.detail-page .tab {
  width: 100%;
  height: calc(100vh - 400px - 92px);
  box-sizing: border-box;
}

.detail-page .van-tab--active {
  font-size: 34px !important;
}

.detail-page .tab-content {
  height: calc(100vh - 88px);
  background: #f7f8fa;
  width: 100vw;
  overflow-y: auto;
  box-sizing: border-box;
}

.detail-page .vip-bar {
  width: 690px;
  height: 100px;
  line-height: 100px;
  margin: 35px auto;
  background: url("https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/vip_bg.png")
    no-repeat center;
  background-size: 100% 100%;
  font-size: 28px;
  color: #70481e;
  box-sizing: border-box;
  padding-left: 84px;
}

.detail-page .vip-bar span {
  font-size: 36px;
  font-weight: 600;
}

.detail-page .vip-bar img {
  float: right;
  width: 36px;
  margin-right: 32px;
  margin-top: 32px;
}

.detail-page .lesson-title {
  font-size: 36px;
  font-weight: 600;
  color: #333333;
  margin-top: 47px;
  padding: 0 35px;
  box-sizing: border-box;
}

.detail-page .lesson-list {
  width: 100vw;
  padding-left: 30px;
  box-sizing: border-box;
  margin-top: 35px;
}

.detail-page .lesson-img {
  width: 690px;
  margin: 24px auto;
}

.detail-page .lesson-item {
  width: 690px;
  height: 162px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 20px;
  padding: 0 28px;
  position: relative;
}

.detail-page .lesson-msg {
  display: flex;
  align-items: center;
  font-size: 26px;
  line-height: 26px;
  color: #666;
  width: 100%;
}

.detail-page .lesson-msg .lesson-time,
.detail-page .lesson-msg .lesson-count,
.detail-page .lesson-msg .lesson-status {
  display: flex;
  align-items: center;
  font-size: 26px;
  line-height: 26px;
  color: #666;
  margin-right: 20px;
  white-space: nowrap;
}

.detail-page .lesson-msg img {
  height: 24px;
  margin-right: 11px;
}

.detail-page .lesson-name {
  padding: 5px 10px 8px;
  color: #000;
  font-size: 34px;
  margin-bottom: 16px;
  width: 100%;
}

.detail-page .free {
  width: 58px;
  height: 32px;
  background: #ff5d5e;
  border-radius: 16px 0 0 16px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  font-size: 22px;
  position: absolute;
  right: 0px;
  top: 30px;
}

.detail-page .play {
  font-size: 24px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-page .play img {
  height: 20px;
  margin-right: 10px;
}

.detail-page .time {
  width: 100%;
  font-size: 24px;
  text-align: right;
  box-sizing: border-box;
  position: absolute;
  right: 10px;
  bottom: 7px;
  color: rgb(85, 85, 85);
}

.is_play .play,
.is_play .time,
.is_play .lesson-name {
  color: #a7090a;
}

.is_play .lesson-name img {
  display: block;
  width: 22px;
  height: 26px;
}

.detail-page .lesson-content {
  width: 690px;
  margin: 20px auto;
  color: #666666;
}

.detail-page .footer {
  width: 100%;
  height: 130px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  box-shadow: 0px -1px 5px 0px rgba(221, 217, 217, 0.5);
}

.detail-page .footer > .vip,
.detail-page .footer > .lesson {
  width: 332px;
  height: 90px;
  border-radius: 45px;
  border: 2px solid #a7090a;
  font-size: 34px;
  color: #a7090a;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
}

.detail-page .footer .vip {
  background: #a7090a;
  color: #fff;
  margin-left: 28px;
}

.share-box {
  width: 750px;
  height: 164px;
  background: #fff;
  border-radius: 20px 20px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.share-box > div {
  margin: 0 65px;
  height: 94px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.share-box img {
  width: 94px;
  margin-right: 18px;
  font-size: 30px;
  color: #333;
}

.share-wrap {
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
}

.share-wrap img:last-of-type {
  width: 137px;
  position: absolute;
  right: 68px;
  top: 0;
}

.share-wrap img:first-of-type {
  width: 269px;
  position: absolute;
  right: 54px;
  top: 140px;
}
</style>
